export default __webpack_public_path__ + "static/mg_logo_local-e2b326cdf80018f8a5c52b0621e0b5ad.svg";